var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fuel container-fluid py-3"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 p-0"},[_c('div',{staticClass:"row"},[_c('OverviewBright')],1),_c('Footer')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }